"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProvidertNotFetched = exports.isAppointmentNotFetched = void 0;
const isAppointmentNotFetched = '@guards/IS_APPOINTMENT_NOT_FETCHED';
exports.isAppointmentNotFetched = isAppointmentNotFetched;
const isProvidertNotFetched = '@guards/IS_PROVIDER_NOT_FETCHED';
exports.isProvidertNotFetched = isProvidertNotFetched;
const guards = {
    // fetch appointment again if appointment or capabilities data is not present
    [isAppointmentNotFetched]: (context) => {
        return !context.appointment || !context.capabilities;
    },
    // fetch provider again if provider data is not present
    [isProvidertNotFetched]: (context) => {
        return !context.provider;
    }
};
exports.default = guards;
//# sourceMappingURL=guards.loadingMachine.js.map